import React, { Component, useState, useEffect } from 'react';
import * as CookieService from '../CookieService';
import Store from '../stores/LoginStore';
import { withTranslation, Trans } from 'react-i18next'
let isFromLink = false;
let strurlParams = "";
let qp = ""
let mob_Session_USERID = ""
let mob_Session_BUSUNIT = ""
let Token = ""
let Password = ""

/*[08/22/22 , PC_04]Accessing STKIssueCart and RMA from mobile for web view - Priyanka D*/
const urlParams = window.location.search;
if (urlParams.includes("?qp_mob")) {
    strurlParams = urlParams.toString()
    let StrURL = strurlParams.split("?qp_mob=")
    let DecodedQueryparams = StrURL[1].toString();

    qp = atob(DecodedQueryparams);
    let QueryParams = qp.split("&")
    mob_Session_USERID = QueryParams[0].replace("mob_Session_USERID=", "");
    mob_Session_BUSUNIT = QueryParams[1].replace("mob_Session_BUSUNIT=", "");
    Password = QueryParams[2].replace("Password=", "");
    Token = QueryParams[3].replace("Token=", "");
    if (mob_Session_USERID || mob_Session_BUSUNIT || Token) {
        isFromLink = true;
    }

}
const FooterContent = (props) => {
    let phonetxt1 = CookieService.getLocalStorageValues("WAL_PHONE_NUM") != null && CookieService.getLocalStorageValues("WAL_PHONE_NUM") != undefined ? CookieService.getLocalStorageValues("WAL_PHONE_NUM") : "";
    let contflag1 = CookieService.getLocalStorageValues("WAL_CONTACT_FLAG") != undefined ? CookieService.getLocalStorageValues("WAL_CONTACT_FLAG") : "";
    let emailId = CookieService.getLocalStorageValues("WAL_EMAIL_ID") != null && CookieService.getLocalStorageValues("WAL_EMAIL_ID") != undefined ? CookieService.getLocalStorageValues("WAL_EMAIL_ID") : "";
    const [contphone, setcontphone] = useState(phonetxt1);
    const [contemail, setcontemail] = useState(emailId);
    const [contflag, setcontflag] = useState(contflag1);
    useEffect(() => {
        Store.on('contactChange', handleChange); // Listening for the change event
        return () => {
            Store.removeListener('contactChange', handleChange); // Cleaning up the event listener on component unmount
        };
    }, []);
    //WW-779 Contact details change - Deepthi N H
    const handleChange = () => {
        setcontphone(CookieService.getLocalStorageValues("WAL_PHONE_NUM") != null && CookieService.getLocalStorageValues("WAL_PHONE_NUM") != undefined ? CookieService.getLocalStorageValues("WAL_PHONE_NUM") : "");
        setcontflag(CookieService.getLocalStorageValues("WAL_CONTACT_FLAG") != undefined ? CookieService.getLocalStorageValues("WAL_CONTACT_FLAG") : "");
        setcontemail(CookieService.getLocalStorageValues("WAL_EMAIL_ID") != null && CookieService.getLocalStorageValues("WAL_EMAIL_ID") != undefined ? CookieService.getLocalStorageValues("WAL_EMAIL_ID") : "");

    };
    if (CookieService.getLocalStorageValues("Session_SITE_CONTACTS")) {
        localStorage.setItem("SDI_SITECONTACTS", CookieService.getLocalStorageValues("Session_SITE_CONTACTS"));
    }
    let SITE_CONTACTS = localStorage.SDI_SITECONTACTS;
    let hyperlink1Txt = "contact sdi customer care";
    let hyperlink1Lnk = "mailto:" + contemail;
    if (SITE_CONTACTS) {
        let siteContacts = SITE_CONTACTS.split("|");
        phonetxt1 = siteContacts(1);
        hyperlink1Txt = siteContacts(2);
        hyperlink1Lnk = siteContacts(3);
    }
    return (
        <div>
            {!isFromLink ?
                <footer id="footer-comp" className="footer">

                    <div className="col-md-12 float-left">
                        <div className="footer-copyrights float-left">
                        </div>
                        <span className="footer-copyrights-content">{`© 2013-${new Date().getFullYear().toString()} sdi, inc.`}<Trans>All rights reserved.</Trans></span>
                        <div className="footer-float-right sdi-footer-text-break">
                            {contflag != "" && contflag != null ? contflag == "P" || contflag == "PE" ? <span className="footer-contacts"><Trans>Call us : </Trans><a href={`tel:+${contphone}`} className="footer-contacts">{contphone}</a></span> : null : null}
                            {contflag != "" && contflag != null ? contflag == "P" || contflag == "PE" ? <span className="footer-slash mx-1">/</span> : null : null}
                            <a href="https://www.sdi.com/" className="footer-contacts">http://www.sdi.com/</a>
                            {contflag != "" && contflag != null ? contflag == "E" || contflag == "PE" ? <span className="footer-slash mx-1">/</span> : null : null}
                            {contflag != "" && contflag != null ? contflag == "E" || contflag == "PE" ? <a href={hyperlink1Lnk} className="footer-contacts"><Trans>contact sdi customer care</Trans></a> : null : null}
                        </div>
                    </div>
                </footer> : null}
        </div>
    )
}
export default withTranslation()(FooterContent);